import { dashboardService } from '../services/dashboard';
import { useFetch } from '../hooks/useFetch';
import Spinner from '../components/Spinner';
import StatusMessage from '../components/StatusMessage';

const Card = ({ label, value }: { label: string; value: string }) => (
  <div className="bg-white border rounded-lg p-5">
    <div className="text-sm text-gray-500">{label}</div>
    <div className="text-2xl font-bold mt-1">{value}</div>
  </div>
);

const Dashboard = () => {
  const { data, loading, error } = useFetch(() => dashboardService.get(), []);
  if (loading) return <Spinner />;
  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold">Dashboard</h1>
      <StatusMessage error={error} />
      {data && (
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-4">
          <Card label="Total Companies" value={String(data.total_companies)} />
          <Card label="Active Subscriptions" value={String(data.active_subscriptions)} />
          <Card label="MRR" value={`Rp ${data.mrr.toLocaleString('id-ID')}`} />
          <Card label="New Companies This Month" value={String(data.new_companies_this_month)} />
          <Card label="Pending Invoices" value={String(data.pending_invoices_count)} />
        </div>
      )}
    </div>
  );
};
export default Dashboard;
